/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesProfileUpdateMarketingEnabledRequest
 */
export interface FxIdWebFeaturesProfileUpdateMarketingEnabledRequest {
    /**
     * 
     * @type {boolean}
     * @memberof FxIdWebFeaturesProfileUpdateMarketingEnabledRequest
     */
    MarketingEnabled: boolean;
}

/**
 * Check if a given object implements the FxIdWebFeaturesProfileUpdateMarketingEnabledRequest interface.
 */
export function instanceOfFxIdWebFeaturesProfileUpdateMarketingEnabledRequest(value: object): value is FxIdWebFeaturesProfileUpdateMarketingEnabledRequest {
    if (!('MarketingEnabled' in value) || value['MarketingEnabled'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesProfileUpdateMarketingEnabledRequestFromJSON(json: any): FxIdWebFeaturesProfileUpdateMarketingEnabledRequest {
    return FxIdWebFeaturesProfileUpdateMarketingEnabledRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileUpdateMarketingEnabledRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesProfileUpdateMarketingEnabledRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'MarketingEnabled': json['MarketingEnabled'],
    };
}

export function FxIdWebFeaturesProfileUpdateMarketingEnabledRequestToJSON(json: any): FxIdWebFeaturesProfileUpdateMarketingEnabledRequest {
    return FxIdWebFeaturesProfileUpdateMarketingEnabledRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesProfileUpdateMarketingEnabledRequestToJSONTyped(value?: FxIdWebFeaturesProfileUpdateMarketingEnabledRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'MarketingEnabled': value['MarketingEnabled'],
    };
}

